import { memo } from 'react';
import { LuX } from 'react-icons/lu';
import { ClearIndicatorProps, components } from 'react-select';
import { Icon } from '@chakra-ui/react';

import { ControlledSelectOption } from '../types/ControlledSelectOption';

const ClearIndicatorComponent = <IsMulti extends boolean = false>({
  children,
  ...props
}: ClearIndicatorProps<ControlledSelectOption, IsMulti>) => (
  <components.ClearIndicator {...props}>
    <Icon as={LuX} boxSize={5} cursor="pointer" />
  </components.ClearIndicator>
);

export const ClearIndicator = memo(
  ClearIndicatorComponent,
) as typeof ClearIndicatorComponent;
